import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { BASEURL } from '../constant/url';
import { MediaFile, MediaFileResponse } from '../interfaces/media_file';

@Injectable({
  providedIn: 'root',
})
export class MediaService {
  private readonly _http = inject(HttpClient);

  uploadFiles(files: File[]): Observable<MediaFile[]> {
    const formData = new FormData();
    files.forEach((file) => formData.append('files', file));
    return this._http.post<MediaFile[]>(`${BASEURL}upload`, formData).pipe(catchError(this.handleError));
  }

  deleteFile(file: MediaFile): Observable<any> {
    return this._http.delete(`${BASEURL}upload/files/${file.id}`).pipe(catchError(this.handleError));
  }

  private handleError = (error: HttpErrorResponse) => {
    let errorMessage = 'Error en el servicio de Archivos/Media.';
    if (error.error && error.error.error && error.error.error.message) {
      errorMessage = error.error.error.message;
    } else if (error.message) {
      errorMessage = error.message;
    }
    console.error('MediaService error:', errorMessage, error.error || error);
    return throwError(() => new Error(errorMessage));
  }
}
